import { ImplicitCallback, SecureRoute } from '@okta/okta-react';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container, Responsive } from 'semantic-ui-react';
import Footer from '../../components/Footer';
import ProfilePage from '../../components/Profile';
import { SiteHeaderDesktop, SiteHeaderMobile } from '../../components/SiteHeader';
import {
  HasTokenOrNull,
  withWapFullLevel,
  withWapUpdateLevel,
  withWapUserAdminLevel,
  withWapVerifyLevel,
} from '../../containers/Authorization';
import EditMemberContainer from '../../containers/EditMember';
import EnrollContainer from '../../containers/Enroll';
import MessageContainer from '../../containers/Message';
import RenewContainer from '../../containers/Renew';
import SearchPage from '../../containers/Search';
import SearchUsersPage from '../../containers/SearchUsers';
import ViewMemberContainer from '../../containers/ViewMember';
import ApolloProviderWrapper from '../ApolloProviderWrapper';
import PaymentPopup from '../PaymentPopup';
import './styles.css';

// IMPORTANT: see https://reactjs.org/docs/higher-order-components.html on why
// it is important NOT TO wrap components inside of render method.

const AuthorizedSearchPage = withWapVerifyLevel(SearchPage);
const AuthorizedSearchUsersPage = withWapUserAdminLevel(SearchUsersPage);
const AuthorizedViewMemberPage = withWapVerifyLevel(ViewMemberContainer);
const AuthorizedEditMemberPage = withWapUpdateLevel(EditMemberContainer);
const AuthorizedEnrollPage = withWapFullLevel(EnrollContainer);
const AuthorizedRenewPage = withWapFullLevel(RenewContainer);
const AuthorizedProfilePage = withWapVerifyLevel(ProfilePage);
const AuthenticatedSiteHeaderMobile = HasTokenOrNull(SiteHeaderMobile);
const AuthenticatedSiteHeaderDesktop = HasTokenOrNull(SiteHeaderDesktop);
const AuthenticatedFooter = HasTokenOrNull(Footer);

const App = () => (
  <ApolloProviderWrapper>
    <React.Fragment>
      <MessageContainer />
      <PaymentPopup />
      <Responsive {...Responsive.onlyMobile}>
        <AuthenticatedSiteHeaderMobile />
      </Responsive>
      <Responsive minWidth={Responsive.onlyTablet.minWidth}>
        <AuthenticatedSiteHeaderDesktop />
      </Responsive>
      <Container id="main" textAlign="justified" styleName="main">
        <Switch>
          <Route path="/implicit/callback" component={ImplicitCallback} />
          <SecureRoute exact path="/search" component={AuthorizedSearchPage} />
          <SecureRoute exact path="/searchusers" component={AuthorizedSearchUsersPage} />
          <SecureRoute exact path="/view" component={AuthorizedViewMemberPage} />
          <SecureRoute exact path="/edit" component={AuthorizedEditMemberPage} />
          <SecureRoute exact path="/enroll" component={AuthorizedEnrollPage} />
          <SecureRoute exact path="/renew" component={AuthorizedRenewPage} />
          <SecureRoute exact path="/update" component={AuthorizedSearchPage} />
          <SecureRoute exact path="/profile" component={AuthorizedProfilePage} />
          <Redirect to="/search" />
        </Switch>
      </Container>
      <div id="footer" styleName="footer">
        <AuthenticatedFooter />
      </div>
    </React.Fragment>
  </ApolloProviderWrapper>
);

export default App;



// WEBPACK FOOTER //
// ./src/app/containers/App/app.js